import { render, staticRenderFns } from "./DragAndDropLayout.vue?vue&type=template&id=05f3da94&"
import script from "./DragAndDropLayout.vue?vue&type=script&lang=js&"
export * from "./DragAndDropLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports